"use strict";

var _classCallCheck = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _require = require("../helpers/create-event-accessor"),
    createEventAccessor = _require.createEventAccessor;

var events = new Set([// WindowEventHandlers
"afterprint", "beforeprint", "beforeunload", "hashchange", "languagechange", "message", "messageerror", "offline", "online", "pagehide", "pageshow", "popstate", "rejectionhandled", "storage", "unhandledrejection", "unload", // inherited and overridden
"blur", "error", "focus", "load", "resize", "scroll"]); // This class builds on GlobalEventHandlers, which must be mixed in first.

var WindowEventHandlersImpl = /*#__PURE__*/function () {
  function WindowEventHandlersImpl() {
    _classCallCheck(this, WindowEventHandlersImpl);
  }

  _createClass(WindowEventHandlersImpl, [{
    key: "_proxyWindowEventsToWindow",
    value: function _proxyWindowEventsToWindow() {
      var _this = this;

      // We're a <body> or <frameset>, so we need to proxy these specific events to the Window (if it exists)
      this._getEventHandlerTarget = function (event) {
        if (events.has(event)) {
          return _this.ownerDocument.defaultView || null;
        }

        return _this;
      };
    }
  }]);

  return WindowEventHandlersImpl;
}();

var _iterator = _createForOfIteratorHelper(events),
    _step;

try {
  for (_iterator.s(); !(_step = _iterator.n()).done;) {
    var event = _step.value;
    createEventAccessor(WindowEventHandlersImpl.prototype, event);
  }
} catch (err) {
  _iterator.e(err);
} finally {
  _iterator.f();
}

module.exports = {
  implementation: WindowEventHandlersImpl
};